/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Checkout_Url_MissingInputs */



/**
* | output |
* | --- |
* | "Checkout session URL was not provided." |
*
* @param {Pricing_Checkout_Url_MissingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_checkout_url_missing = /** @type {((inputs?: Pricing_Checkout_Url_MissingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Checkout_Url_MissingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Checkout-Session-URL wurde nicht bereitgestellt.")
	return /** @type {LocalizedString} */ ("Checkout session URL was not provided.")
});